import { render } from "./PendingDeposits.vue?vue&type=template&id=7acbd1e1&scoped=true&ts=true"
import script from "./PendingDeposits.vue?vue&type=script&lang=ts"
export * from "./PendingDeposits.vue?vue&type=script&lang=ts"

import "./PendingDeposits.vue?vue&type=style&index=0&id=7acbd1e1&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7acbd1e1"]])

export default __exports__